import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import CheckoutEntryContainer from 'core/containers/CheckoutEntryContainer';
import MiniFooter from 'core/components/Footer/MiniFooter';
import MiniHeader from 'core/components/Header/MiniHeader';
import CartCheckoutPageContainer from './CartCheckoutPageContainer';

const PageContent = styled.div`
	flex: 1;
`;

/**
 * Render the `CartCheckoutPageContent`
 * page wrapper rendered into `div#PageContent`
 * top of React tree, full page render of:
 * - CheckoutEntryContainer: To provider Cart & Order contexts
 * - MiniHeader/PageContainer/MiniFooter
 *
 * Available to SSR
 */
const CartCheckoutPageContent = ({ headerProps, pageProps }) => {
	headerProps = headerProps || {};
	pageProps = pageProps || {};
	return (
		<CheckoutEntryContainer cartId={pageProps?.cartId} mpOrderId={pageProps?.mpOrderId}>
			<MiniHeader {...headerProps} />
			<PageContent>
				<CartCheckoutPageContainer {...pageProps} />
			</PageContent>
			<MiniFooter />
		</CheckoutEntryContainer>
	);
};

CartCheckoutPageContent.propTypes = {
	headerProps: PropTypes.object,
	pageProps: PropTypes.shape({
		cartId: PropTypes.number,
		mpOrderId: PropTypes.number,
	}),
};

export default hot(module)(CartCheckoutPageContent);
